import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../../Sidebar/AdminSidebar';
import AdminNavbar from '../../Navbars/AdminNavbar';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const AdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const userLoginData = useSelector((state: any) => state.data.login.value);
  
  // Check if the user is logged in and is a superadmin
  const isAuthenticated = !!userLoginData?.token;
  const isAdmin = isAuthenticated && 
    (userLoginData?.data?.user_data?.role === 'superadmin' || 
     userLoginData?.data?.user_data?.role === 'admin');

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminSidebar 
        isMobile={sidebarOpen} 
        onCloseMobileMenu={() => setSidebarOpen(false)} 
      />
      
      <div className="md:ml-64 flex flex-col min-h-screen">
        <AdminNavbar onMenuButtonClick={() => setSidebarOpen(!sidebarOpen)} />
        
        <main className="flex-grow p-4 md:p-6 mt-16">
          <Outlet />
        </main>
        
        <footer className="bg-white p-4 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Beternal. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;